<template>
	<div class="usermana">
		<!-- 表头 -->
		<div class="button-group">
			<!-- 刷新表单 -->
			<el-button type="success" @click="fetchCourseList">刷新</el-button>
			<div class="search">
				<el-select v-model="filter.closed" placeholder="请选择是否结课" size="large" @change="updateFilter" clearable >
					<el-option label="已结课" value="1"></el-option>
					<el-option label="未结课" value="0"></el-option>
				</el-select>
				<el-date-picker v-model="filter.semester" type="year" placeholder="请选择开课年份" size="large" style="width: 300px;"
					@change="updateFilter" />
			</div>
		</div>

		<!-- 表单 -->
		<el-config-provider :locale="zhCn">
			<el-table :row-class-name="rowClassName" :data="courseList" highlight-current-row
				style="width: 100%; margin-top: 2vh; margin-bottom: 2vh"
				:default-sort="{ prop: 'createDate', order: 'descending' }">

				<el-table-column label="课程号" prop="courseNum" :width="'auto'" />
				<el-table-column label="学期" prop="semester" :width="'auto'" />
				<el-table-column label="课程名称" prop="courseName" :width="'auto'" />
				<el-table-column v-if="false" label="开课日期" prop="createDate" :width="'auto'" :sortable="true" />
				<el-table-column label="结课状态" prop="closed" :formatter="formatClosed" :width="'auto'" />
				<el-table-column label="课程简介" prop="courseBrief" :width="'auto'" >
					<template #default="scope">
						<el-button @click="enterBrief(scope.row)">简介</el-button>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="相关资料" width=300px>
					<template #default="scope">
						<el-button @click="getData(scope.row)">资料</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 页面分页功能 -->
			<el-pagination :page-size="limit" :total="total" v-model:current-page="page" @click="fetchCourseList" />
		</el-config-provider>
		
	</div>
</template>
	
<script>
import { defineComponent, } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

export default defineComponent({
	data() {
		return {
			filter: {
				semester: "",
				dateStart: "",
				dateEnd: "",
				closed: "",
			},
			courseList: [],
			page: 1,
			limit: 9,
			total: 0,
			interval: null,
			zhCn,
		};
	},
	// 刷新页面
	async mounted() {
		this.fetchCourseList();
		this.interval = setInterval(() => {
			this.fetchCourseList();
		}, 5000);
	},
	unmounted() {
		clearInterval(this.interval);
	},
	setup() {
	},
	methods: {
		// 表格背景
		rowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? "even-row" : "odd-row";
		},
		// 格式化 "结课状态" 字段
		formatClosed(row, column, cellValue) {
			return cellValue === 1 ? '已结课' : '未结课';
		},
		updateFilter() {
			if (this.filter.semester) {
				// 选择年份后更新 dateStart 和 dateEnd
				const year = this.filter.semester.getFullYear();  // 获取选择的年份

				// 设置 filter.dateStart 为该年份的 1月1日
				this.filter.dateStart = `${year}-01-01`;

				// 设置 filter.dateEnd 为该年份的 12月31日
				this.filter.dateEnd = `${year}-12-31`;

				console.log('更新后的日期范围:', this.filter.dateStart, this.filter.dateEnd);
			} else {
				// 如果没有选择年份，清空 dateStart 和 dateEnd
				this.filter.dateStart = '';
				this.filter.dateEnd = '';
			}
			this.fetchCourseList();
		},
		//获取课程表单
		async fetchCourseList() {
			try {
				const response = await this.$axios.post("/api/course/list", {
					dateStart: this.filter.dateStart,
					dateEnd: this.filter.dateEnd,
					closed: this.filter.closed,
					pageNum: this.page,
					pageLimit: this.limit,
				});

				this.courseList = response.data.courseList; // 根据你的数据结构调整
				this.total = response.data.total;
			} catch (error) {
				console.error("An error occurred while fetching the dev list:", error);
			}
		},
		// 进入资料 
		getData(row){
			this.$router.push({ name:'studentresource',params:{courseId:row.id,courseName:row.courseName}})
		},

		// 进入课程简介页
		enterBrief(row) {
			this.$router.push({ name: 'studentclassbrief', params: { courseId: row.id } })
		}
	},
});
</script>
	
<style scoped>
:deep .even-row {
	background-color: #f0f0f0;
	/* 设置偶数行的背景色 */
}

:deep .odd-row {
	background-color: #ffffff;
	/* 设置奇数行的背景色 */
}

.button-group {
	display: flex;
	/* background-color: yellow; */
	height: 4vh;
}

.el-button {
	height: 100%;
	margin-right: 6px;
}

.el-pagination {
	margin-top: 1vh;
	position: absolute;
	bottom: 1vh;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

:deep .el-dialog__body {
	padding-top: 16px;
}
</style>
	